import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ErrorHandling } from "../../../common/classes/ErrorHandling";
import { LoginType } from "../../pages/login/login.component";
import { InputType } from "../../../common/components/input/enum/InputType";
import { CustomerApi } from "../../../common/apis/customer-api";
import { MerchantApi } from "../../../common/apis/merchant-api";
import { MerchantLoginService } from "../../../common/services/merchant-login.service";
import { EmailApi } from "../../../common/apis/email-api";
import { RedirectService } from "../../../common/services/redirect.service";
import { isFormSubmitted } from "../../../common/utilities/FormsHelper";
import { JWTToken } from "../../../common/interfaces/JWTToken";
import { ValidationErrorType } from "../../../common/enums/ValidationErrorType";

@Component({
  selector: 'login-alert',
  templateUrl: './login-alert.component.html',
  styleUrls: ['./login-alert.component.scss']
})
export class LoginAlertComponent {
  @ViewChild('mobileNumberVerificationModal') modal!: ElementRef;


  public showPasswordFieldText = false;
  public signInForm: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType;
  Validators = Validators

  inputEmail = ''
  inputPassword = ''

  emailLabel: string = $localize`:@@emailLabel:Email`;
  passwordLabel: string = $localize`:@@passwordLabel:Password`;
  loginLabel: string = $localize`:@@login:Login`;
  loginType: LoginType = 'customer'

  warningMessage: string | null= null


  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private renderer: Renderer2,

    private customerApi: CustomerApi,
    private merchantApi: MerchantApi,
    private merchantLoginService: MerchantLoginService,
    private emailApi: EmailApi,
    private redirectService: RedirectService

  ) {
  }



  ngOnInit(): void {

  }


  showScreen(p:{warningMessage :string, }) {
    this.warningMessage = p.warningMessage
     this.onSuccess = new EventEmitter<void>();
    this.openModal()
  }

  submitMobileNumberVerificationForm() {
  }


  openModal() {
    this.renderer.addClass(this.modal.nativeElement, 'show');
    this.renderer.setStyle(this.modal.nativeElement, 'display', 'block');
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  closeModal() {
    this.renderer.removeClass(this.modal.nativeElement, 'show');
    this.renderer.setStyle(this.modal.nativeElement, 'display', 'none');
    this.renderer.removeStyle(document.body, 'overflow');
  }

  onContainerClicked(event: MouseEvent): void {
    if ((event.target as Element).classList.contains('modal')) {
      this.closeModal();
    }
  }

  onTextChange(text:any){


  }


  submit(){
    // const value = this.form.get("commentId")?.value;
    // this.onSuccess.emit(value)
    this.closeModal();
  }


  updateInputFieldById(id: string, value: any) {
    if (id == "email") {
      this.inputEmail = value;
    } else if (id == "password") {
      this.inputPassword = value;
    }
  }

  onForgotPassword() {
    if (this.loginType === 'customer')
      this.router.navigate(['/customers/signup/customer-forget-password']).then()
    else
      this.router.navigate(['/merchants/forget-password']).then()
  }

  onLoginSubmitted() {
    if (isFormSubmitted(this.signInForm)) {
      let email = this.inputEmail;
      let password = this.inputPassword;
      this.isLoading = true;
      if (this.loginType === "customer") {
        this.customerLogin(email, password)
      } else {
        this.merchantLogin(email, password)
      }
    }
  }

  customerLogin(email: string, password: string) {
    this.customerApi.customerLogin(email, password).subscribe({
      next: (_: JWTToken) => {
        console.log("Logged in successfully")
        // this.redirectService.redirectStoreUrl()
        this.onLoginSuccess()
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        if (error == ValidationErrorType.emailNotVerified) {
          this.verifyCustomerEmail();
        } else {
          this.serverError = error
        }
      }
    })
  }


  merchantLogin(email: string, password: string) {
    this.merchantApi.merchantLogin(email, password).subscribe({
      next: (result: JWTToken) => {
        console.log("Logged in successfully")
        this.merchantLoginService.redirectToLogin(result);
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        if (error === ValidationErrorType.emailNotVerified) {
          this.verifyMerchantEmail();
        } else {
          if (error === ValidationErrorType.UNAUTHORIZED)
            this.serverError = $localize`Incorrect username and/or password.`
          else
            this.serverError = $localize`Something went wrong. Please try again later or contact support.`
        }
      }
    })
  }


  onLoginSuccess(){
    this.closeModal()
    this.onSuccess.emit()

  }

  verifyCustomerEmail() {
    let email = this.inputEmail;
    this.customerApi.resendEmailVerification(email).subscribe({
      next: (_) => {
        this.isLoading = false;
        this.router.navigate(["/customers/signup/email-confirmation"]).then()
      },
      error: _ => {
        this.router.navigate(["/customers/signup/email-confirmation"]).then()
        this.isLoading = false;
        // this.serverError = error
      }
    })
  }


  goToSignup() {
    if (this.loginType === 'customer') {
      return '/customers/signup'
    } else {
      return '/merchants/signup'
    }
  }

  verifyMerchantEmail(){
    let email = this.inputEmail;
    this.emailApi.resendVerificationEmail(email).subscribe({
      next: (_) => {
        this.isLoading = false;
        this.router.navigate(["/merchants/email-confirmation"]).then()
      },
      error: _ => {
        this.router.navigate(["/merchants/email-confirmation"]).then()
        this.isLoading = false;
        // this.serverError = error
      }
    })
  }

}
